import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { AutoImage } from './auto-image'
import { ColoredTableOuter, ColoredTableItem, ColoredTableHead, ColoredTableBody, ColoredTableSubject } from './color-table'

const Outer = styled.div`
  margin-top: 2rem;
  @media (max-width: 40rem){
    margin-top: 0;
  }
`

const ImageContainer = styled.div`
  margin-top: 2rem;
  img {
    width: 100%;
    height: auto;
    display: block;
  }
`

type SyukatsuSectionProps = {

}
export const SyukatsuSection: FunctionComponent<SyukatsuSectionProps> = () => {
  return <Outer>
    <ColoredTableOuter style={{'--columns': 5}}>
      <ColoredTableItem>
        <ColoredTableHead style={{backgroundColor: '#ed8599'}}>
          4月〜
        </ColoredTableHead>
        <ColoredTableBody>
          <ColoredTableSubject>就職フェア</ColoredTableSubject>
          <ColoredTableSubject>園見学会</ColoredTableSubject>
          就職フェア・園見学会の日程は、リクルートサイトにてご確認ください。また、都合がつかない場合は、別日程でも対応します。お気軽にお問い合わせください。
        </ColoredTableBody>
      </ColoredTableItem>
      <ColoredTableItem>
        <ColoredTableHead style={{backgroundColor: '#a6ca5e'}}>
          8月
        </ColoredTableHead>
        <ColoredTableBody>
          <ColoredTableSubject>ワンデー体験</ColoredTableSubject>
          <ColoredTableSubject>夏期アルバイト</ColoredTableSubject>
          先生体験を通して、子どもたちの様子や先輩先生の雰囲気がよくわかります。
          随時申し込みを受け付けていますので、お気軽にご連絡ください。
        </ColoredTableBody>
      </ColoredTableItem>
      <ColoredTableItem>
        <ColoredTableHead style={{backgroundColor: '#eea76e'}}>
          6月 〜11月
        </ColoredTableHead>
        <ColoredTableBody>
          <ColoredTableSubject>就職試験ー</ColoredTableSubject>
          園見学終了次第、随時開催します。試験日については直接、お問い合わせください。
        </ColoredTableBody>
      </ColoredTableItem>
      <ColoredTableItem>
        <ColoredTableHead style={{backgroundColor: '#9d92c1'}}>
          11月〜1月
        </ColoredTableHead>
        <ColoredTableBody>
          <ColoredTableSubject>内定者説明会</ColoredTableSubject>
          今後のスケジュールなどを確認します。生活発表会やもちつき会などの大きな行事への見学も案内します。
        </ColoredTableBody>
      </ColoredTableItem>
      <ColoredTableItem>
        <ColoredTableHead style={{backgroundColor: '#00b2cc'}}>
          2月～3月
        </ColoredTableHead>
        <ColoredTableBody>
          <ColoredTableSubject>内定者研修</ColoredTableSubject>
          実習のようなスタイルで、手当も支給します。4月からのスタートをスムーズにするためにも、1日でも多くの研修に参加することをおすすめします。
        </ColoredTableBody>
      </ColoredTableItem>
    </ColoredTableOuter>
    <ImageContainer>
      <AutoImage src='/images/req_img_05.png' mobileSrc='/images/req_img_05_mobile.png'/>
    </ImageContainer>
  </Outer>
}